"use client";

import React, { useState, useRef } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowUpRight, ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
interface MinistryCard {
  id: number;
  title: string;
  description: string;
  image: string;
  srcset: string;
  sizes: string;
  alt: string;
  link: string;
}
const ministriesData: MinistryCard[] = [{
  id: 1,
  title: "MINISTERIO A LOS NIÑOS",
  description: "Nutrimos el corazón y la mente de los jóvenes en la fe a través de programas interactivos, aprendizaje bíblico y modelos positivos a seguir.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/children_ministry_group.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/children_ministry_group.png-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 25vw",
  alt: "Grupo de niños sonriendo en el ministerio infantil",
  link: "#"
}, {
  id: 2,
  title: "BGMC",
  description: "Inspiramos a los niños a amar a Jesús, amar a las naciones y comprometerse con una vida de generosidad.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/children_bgmc_circle.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/children_bgmc_circle.png-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 25vw",
  alt: "Niños en círculo mirando hacia la cámara",
  link: "#"
}, {
  id: 3,
  title: "FAITH CASE",
  description: "Proporcionamos a los padres y cuidadores herramientas y recursos para nutrir la fe de sus hijos y afrontar los desafíos de la vida familiar.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/children_faith_case_parent.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/children_faith_case_parent.png-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 25vw",
  alt: "Niña jugando feliz con su familia al aire libre",
  link: "#"
}, {
  id: 4,
  title: "BIBLIA DE PODER PARA NIÑOS",
  description: "Despertamos la pasión por la Palabra de Dios en los niños a través de actividades de narración interactivas de historias atractivas y lecciones bíblicas memorables.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/children_power_bible_reading.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/children_power_bible_reading.png-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 25vw",
  alt: "Niña pequeña leyendo la biblia infantil con atención",
  link: "#"
}];
export default function Childrenministriesgrid() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const shouldReduceMotion = useReducedMotion();
  const handleScroll = (direction: "left" | "right") => {
    if (scrollContainerRef.current) {
      const scrollAmount = 320;
      scrollContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth"
      });
    }
  };
  return <section id="childrenministriesgrid" data-nav="light" className="relative w-full bg-background py-10 md:py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="relative">
          {}
          <div className="pointer-events-none absolute -left-3 -right-3 top-1/2 z-20 hidden -translate-y-1/2 items-center justify-between sm:flex lg:-left-5 lg:-right-5">
            <Button type="button" variant="secondary" size="icon" aria-label="Desplazar hacia la izquierda" onClick={() => handleScroll("left")} className="pointer-events-auto size-10 rounded-full border border-border/40 bg-foreground/75 text-background shadow-md transition-[background-color,transform] hover:scale-105 hover:bg-foreground">
              <ChevronLeft className="size-5" />
            </Button>
            <Button type="button" variant="secondary" size="icon" aria-label="Desplazar hacia la derecha" onClick={() => handleScroll("right")} className="pointer-events-auto size-10 rounded-full border border-border/40 bg-foreground/75 text-background shadow-md transition-[background-color,transform] hover:scale-105 hover:bg-foreground">
              <ChevronRight className="size-5" />
            </Button>
          </div>

          {}
          <div ref={scrollContainerRef} className="flex gap-4 overflow-x-auto pb-4 pt-2 scrollbar-none sm:grid sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
            {ministriesData.map((ministry, i) => <motion.div key={ministry.id} data-index={i} initial={shouldReduceMotion ? {
            opacity: 1
          } : {
            opacity: 0,
            y: 20
          }} whileInView={shouldReduceMotion ? {
            opacity: 1
          } : {
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="group relative flex min-w-[280px] flex-col overflow-hidden rounded-2xl border border-border/60 bg-card shadow-sm transition-[box-shadow,border-color] duration-300 hover:border-border hover:shadow-md sm:min-w-0">
                {}
                <div className="relative aspect-[4/5] w-full overflow-hidden sm:aspect-[3/4] lg:aspect-[4/5]">
                  <img src={ministry.image} data-wvc-srcset={ministry.srcset} data-wvc-sizes={ministry.sizes} alt={ministry.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105" />

                  {}
                  <div className="absolute right-3.5 top-3.5 z-10">
                    <div className="flex size-9 items-center justify-center rounded-full bg-background/95 text-foreground shadow-sm transition-[background-color,transform] group-hover:scale-110">
                      <ArrowUpRight className="size-4" />
                    </div>
                  </div>
                </div>

                {}
                <div className="relative -mt-16 mx-3 mb-3 flex flex-1 flex-col justify-between rounded-xl border border-border/40 bg-card/95 p-4 shadow-sm backdrop-blur-xs transition-[background-color] sm:p-5">
                  <div>
                    <h3 className="text-base font-bold tracking-tight text-card-foreground sm:text-lg">
                      {ministry.title}
                    </h3>
                    <p className="mt-2 text-xs leading-relaxed text-muted-foreground line-clamp-4 sm:text-sm">
                      {ministry.description}
                    </p>
                  </div>

                  <div className="mt-4 pt-1">
                    <Button asChild variant="default" size="sm" className="group/btn h-8 rounded-full bg-foreground px-3.5 text-xs font-semibold text-background transition-[background-color,transform] hover:bg-foreground/90">
                      <Link to={ministry.link} className="inline-flex items-center gap-1.5">
                        <span>{"MÁS INFORMACIÓN"}</span>
                        <div className="flex size-4 items-center justify-center rounded-full bg-background/20 text-background">
                          <ArrowUpRight className="size-3 transition-transform group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5" />
                        </div>
                      </Link>
                    </Button>
                  </div>
                </div>

                {}
                <div className="h-1 w-full bg-secondary/30 transition-colors group-hover:bg-secondary" />
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}